module.exports = __webpack_public_path__ + "img/fabric6.8cf43d87.jpg";